module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage table5E"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("奖项名称：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpBig"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.hjName),
      callback: function($$v) {
        _vm.$set(_vm.params, "hjName", $$v)
      },
      expression: "params.hjName"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("表彰对象：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.bzObject),
      callback: function($$v) {
        _vm.$set(_vm.params, "bzObject", $$v)
      },
      expression: "params.bzObject"
    }
  }, _vm._l((_vm.dicDats['C023']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("奖励内容：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpTextArea"
  }, [_c('el-input', {
    attrs: {
      "rows": 3,
      "type": "textarea",
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.commend),
      callback: function($$v) {
        _vm.$set(_vm.params, "commend", $$v)
      },
      expression: "params.commend"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("颁奖单位：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.bjName),
      callback: function($$v) {
        _vm.$set(_vm.params, "bjName", $$v)
      },
      expression: "params.bjName"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("获奖级别：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp edSelect"
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.hjLevel),
      callback: function($$v) {
        _vm.$set(_vm.params, "hjLevel", $$v)
      },
      expression: "params.hjLevel"
    }
  }, _vm._l((_vm.dicDats['C024']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  })), _vm._v(" "), (_vm.dicMap['C024'][_vm.params.hjLevel] == '其他') ? _c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.hjLevelOther),
      callback: function($$v) {
        _vm.$set(_vm.params, "hjLevelOther", $$v)
      },
      expression: "params.hjLevelOther"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("表彰时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.hjDate),
      callback: function($$v) {
        _vm.$set(_vm.params, "hjDate", $$v)
      },
      expression: "params.hjDate"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("表 5：获得表彰情况登记表")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66c9f569"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/SPEC/glanceDcp/table5.vue
// module id = 1761
// module chunks = 1